export default function getGiftMembershipCost({
  membershipPrices,
  selectedMembershipType,
}) {
  return membershipPrices[selectedMembershipType]
}
